import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import addRequestFormReducer from "./reducers/request/create/form";
import detailsRequestFormReducer from "./reducers/request/detail/form";
import userSignupFormReducer from "./reducers/signup/form";
import userClaimsSlice from "./reducers/signup/claims";
import catalogReducer from "./reducers/catalog/catalog";
import requestListReducer from "./reducers/request/list/list";
import globalLoadingReducer from "./reducers/globalLoading/globalLoading";
import errorOnRequestReducer from "./reducers/api/errorOnRequest";
export const store = configureStore({
    reducer: {
        addRequestForm: addRequestFormReducer,
        detailsRequestForm: detailsRequestFormReducer,
        userSignupForm: userSignupFormReducer,
        userClaims: userClaimsSlice,
        catalog: catalogReducer,
        requestList: requestListReducer,
        globalLoading: globalLoadingReducer,
        errorOnRequest: errorOnRequestReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    devTools: process.env.NODE_ENV === "development",
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, any, Action<string>>;
